import React, { useState, createContext } from 'react';

export const MenuContext = createContext();
export const MenuDispatcherContext = createContext();

function MenuProvider({ children }) {
  const [state, setState] = useState([]);

  return (
    <MenuContext.Provider value={state}>
      <MenuDispatcherContext.Provider value={setState}>{children}</MenuDispatcherContext.Provider>
    </MenuContext.Provider>
  );
}

export { MenuProvider };
